import { render, staticRenderFns } from "./SucessAirtime.vue?vue&type=template&id=234f2880&scoped=true&"
import script from "./SucessAirtime.vue?vue&type=script&lang=js&"
export * from "./SucessAirtime.vue?vue&type=script&lang=js&"
import style0 from "./SucessAirtime.vue?vue&type=style&index=0&id=234f2880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f2880",
  null
  
)

export default component.exports